// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"223":"bce13e01","422":"209e83ab","455":"b11a970b"}[chunkId] + ".chunk.js";
};